import React, { useState } from "react";
import img from "./assets/img.png";
import check from "./assets/check.png";
const Tabs = () => {
  const [activeTabs, setActiveTabs] = useState(0);
  const getActiveClass = (i) => {
    if (i === activeTabs) {
      return "active";
    }
    return "";
  };
  const data = [
    { time: "8 hours ago", subTitle: "bought", value: "9.89" },
    { time: "at 06/10/2021, 3:20 AM", subTitle: "bid accepted", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
    { time: "8 hours ago", subTitle: "place a bid", value: "4.89" },
  ];
  const Card = ({ time, subTitle, value }) => (
    <div className="flex h-[56px] w-full xl:max-w-[557px] gap-[12px]">
      <div className="">
        <div className="inline-block relative">
          <img className="rounded-[13px]" src={img} alt="" />
          <div className="absolute right-0 bottom-0">
            <img src={check} className="w-[12px]" alt="" />
          </div>
        </div>
      </div>
      <div className="flex justify-between grow border-b border-[#1F1F2C] pb-[14px]">
        <div className="text-[13px] leading-[20px] text-[#EBEBEB]">
          <h2 className="flex ">
            <span className="text-[15px] leading-[22px] font-bold inline-block mr-[6px] text-white">
              0x736f...6245a9
            </span>{" "}
            <span>{subTitle}</span>
          </h2>
          <h4>{time}</h4>
        </div>
        <div>
          <h2 className="text-[14px] leading-[22px] font-bold mr-[6px]">
            {value} ETH
          </h2>
          <h4 className="text-[13px] leading-[20px] text-[#EBEBEB] ">
            {" "}
            = $12.246
          </h4>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      <div className="tabs-wrap max-w-full 2xl:max-w-[557px] h-[35px]">
        <ul className="flex flex-wrap gap-[10px] md:gap-[50px]">
          <li>
            <button
              onClick={() => setActiveTabs(0)}
              className={getActiveClass(0)}
            >
              Tx History
            </button>
          </li>
          <li>
            <button
              onClick={() => setActiveTabs(1)}
              className={getActiveClass(1)}
            >
              Vesting History
            </button>
          </li>
          <li>
            <button
              onClick={() => setActiveTabs(2)}
              className={getActiveClass(2)}
            >
              Raise History
            </button>
          </li>
        </ul>
      </div>
      <div className="mt-[21px] flex flex-col gap-[12px] tab-content">
        {activeTabs === 0
          ? data.map((single, i) => <Card key={i} {...single}></Card>)
          : activeTabs === 2
          ? data
              .slice(1, 4)
              .map((single, i) => <Card key={i} {...single}></Card>)
          : data
              .slice(1, 5)
              .map((single, i) => <Card key={i} {...single}></Card>)}
      </div>
    </div>
  );
};

export default Tabs;
